/**
 * Map the ad-wizard advertiser (individual/corporate + id number) to REGA's
 * advertiser `idType`. Confirmed against the LIVE REGA validator on 2026-08-09:
 *   1 = National ID — ONLY Saudi national IDs, which always start with 1
 *   2 = Entity — covers Iqamas (start 2) AND company Unified Numbers (start 7)
 *   3 = rejected by REGA for advertisers ("نوع الهوية غير صحيح")
 *
 * Verified with advertiser 7026186689 (a unified number): idType 1 ✗ and 3 ✗
 * both returned "نوع الهوية غير صحيح", so a unified number must be sent as 2.
 *
 * The rule is prefix-driven, NOT toggle-driven, so a mis-set individual/corporate
 * selector can never send 1 or 3 for a non-national number: a national ID (starts
 * with 1, and not marked corporate) → "1"; everything else → "2".
 */
export function regaIdType(
  advertiserKind: string | undefined,
  idNumber: string | undefined,
): '1' | '2' {
  return advertiserKind !== 'corporate' && (idNumber || '').startsWith('1') ? '1' : '2';
}
